import { useStore } from "@nanostores/react";
import { useEffect, useState } from "react";
import { isDonationWindowHiddden } from "../../stores/sessionStore";
import configJson from "../../data/app-config.json";

const convertToISOFormat=(dateStr)=> {
    const [month, day, year] = dateStr.split('/');
    return `${year}-${month}-${day}`; // Converts to YYYY-MM-DD
}

const FloatingDonateButton=({isHomePage})=>{
    const [isComponentVisible, setIsComponentVisible] = useState(false);
    const [muharramDayDifference, setMuharramDayDifference] = useState(null);
    const [muharramYear, setMuharramYear] = useState(null);
    const [isMediaPlayerVisible, setIsMediaPlayerVisible] = useState(false);

    const globalDonationWindowVisibility=useStore(isDonationWindowHiddden);

    const handleCompomentVisibility=()=>{
        setIsComponentVisible(false);
        sessionStorage.donationComponentVisited="visited";
    }

    useEffect(()=>{
        if(globalDonationWindowVisibility)
        {
            setIsComponentVisible(false);
        }
    },[globalDonationWindowVisibility]);

    useEffect(()=>{
        if(isHomePage!=="1"&&!window.location.pathname.includes("/donate")&&sessionStorage.donationComponentVisited!=="visited")
        {
            setIsComponentVisible(true);
        }

        const hajjDate = configJson.next_muharram_date;
        const formattedHajjDate = convertToISOFormat(hajjDate);
        const date1 = new Date(new Date().toISOString());
        const date2 = new Date(formattedHajjDate);
        const Difference_In_Time = date2.getTime() - date1.getTime();
        const Difference_In_Days = Math.floor(Difference_In_Time / (1000 * 3600 * 24));
        setMuharramYear(date2.getFullYear());
        setMuharramDayDifference(Difference_In_Days);

        // code to dynamically position the donate button based on media player visibility
        const handleVisibilityChange = (event) => {
            if (event?.detail?.visible !== undefined) {
                setIsMediaPlayerVisible(event.detail.visible);
            }
        };

        // Add event listener for "alimMediaPlayerVisibility"
        window.addEventListener('alimMediaPlayerVisibility', handleVisibilityChange);

        // Clean up on unmount
        return () => {
            window.removeEventListener('alimMediaPlayerVisibility', handleVisibilityChange);
        };
    },[]);

    return(
        <>
            {
                isComponentVisible?
                    <div className={`flex flex-col alim-text-color-style mt-8 mb-3 md:mt-0 w-[210px] fixed right-[30px] ${isMediaPlayerVisible?`bottom-[75px]`:`bottom-[20px]`} w-[180px] z-[21]`}>
                        <div className="bg-dark-grey-index dark:bg-deep-blue rounded-t-md py-2 text-white flex justify-between">
                            <h4 className="font-medium text-[22px] ml-5">Donate</h4>

                            <button type="button" className="modal-close-btn inline-flex justify-center items-center hover:bg-light-blue w-8 h-8 rounded-lg mr-1" onClick={handleCompomentVisibility}>
                                <img src="/images/close.svg" className="w-[12px] h-[12px]" alt="close icon"/>
                                <span className="sr-only">Close window</span>
                            </button>
                        </div>
                        <div className="blue-gr-box rounded-b-md text-center flex flex-col items-center">
                            
                            <p className="italic">
                                Donate & Earn Sadaqah Jariyah
                            </p>

                            <a href={`/donate`} className="bg-deep-red rounded-full px-[15px] py-[5px] text-sm mt-2.5 text-white red-button-hover-style" title="Donate to Alim">
                                Donate
                            </a>

                            {
                                muharramYear&&muharramDayDifference!==null&&muharramDayDifference>=-30?
                                    <a href={`/muharram`} className="text-sm mt-2.5 underline hover:text-deep-red" title={`Visit Muharram ${muharramYear} page`}>
                                        Muharram {muharramYear}
                                    </a>
                                :
                                    null
                            }
                        </div>
                    </div>
                :
                    null
            }
        </>
    )
}

export default FloatingDonateButton;